<template>
  <div style="margin: 16px 24px;">
    <!-- 标题 -->
    <mtd-row style="margin-top:37px;">
      <mtd-col :span="24">
        <span class="dd-page-title">文件外发</span>
      </mtd-col>
    </mtd-row>
    <!-- 图标展示 -->
    <mtd-row style="margin-top:64px;">
      <!-- 审批中状态 -->
      <mtd-col :span="24" v-if="bpmStatus === 0" style="text-align: center;">
        <i class='mtdicon-time' style="color: #0A70F5;font-size: 56px;"></i>
        <div class="bpm-status-title">{{ checkingResult }}</div>
        <div style="height: 72px"></div>
      </mtd-col>
      <!-- 审批通过状态 -->
      <mtd-col :span="24" v-if="bpmStatus === 1" style="text-align: center;">
        <i class='mtdicon-success-circle' style="color: #00b365;font-size: 56px;"></i>
        <div class="bpm-status-title" v-if="emailFlag">{{ passAndEmailResult }}</div>
        <div class="bpm-status-title" v-else="emailFlag">{{ passResult }}</div>
        <div style="height: 72px"></div>
      </mtd-col>
      <!-- 审批未通过状态 -->
      <mtd-col :span="24" v-if="bpmStatus && bpmStatus !== 0 && bpmStatus !== 1" style="text-align: center;">
        <i class='mtdicon-error-o' style="color: #FF5F57;font-size: 56px;"></i>
        <div class="bpm-status-title">{{ noPassResult }}</div>
        <div style="height: 72px"></div>
      </mtd-col>
    </mtd-row>
    <!-- 提示信息 -->
    <mtd-row>
      <mtd-col :span="24" style="text-align: center;">
        <div style="width: 664px;display: inline-block">
          <mtd-announcement title="外发记录已同步至您的上级，非工作目的外发，将会面临处罚" type="warning" show-icon/>
        </div>
      </mtd-col>
    </mtd-row>
    <!-- 外发信息 -->
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="24" style="text-align: center;">
        <div style="width: 664px;display: inline-block">
          <mtd-row justify="center" type="flex">
            <div class="file-out-result-title-complete">
              <span>外发信息</span>
              <span style="color: #FF5F57;float: right">
                <span v-if="bpmStatus !== 1">
                  审批成功后，该链接才能被访问
                </span>
                <span v-if="bpmStatus === 1">
                  <i class='mtdicon-time' style="margin-right: 4px;"/>
                  链接于{{ applyCreateTime }}创建，{{ applyExpireHours }}后过期
                </span>
              </span>
            </div>
          </mtd-row>
          <mtd-row justify="center" type="flex">
            <div class="file-out-result-content-complete">
              <div class="complete-content-tips">
                <span class="tips">1.复制分享链接和提取密码，发送给相关人员</span>
                <mtd-button class="tips-button" type="text" icon="mtdicon mtdicon-copy-o" @click="copyUrl()"
                            v-clipboard:copy="copyMessage" v-clipboard:success="copySuccess"
                            v-clipboard:error="copyError">复制
                </mtd-button>
              </div>
              <mtd-form style="margin-top: 12px;">
                <mtd-form-item class="shared-link-wrapper" label="文件分享链接:" style="margin-bottom: 8px;min-height: 22px">
                  <span class="shared-link">{{ fileOutUrl }}</span>
                </mtd-form-item>
                <mtd-form-item class="shared-link-wrapper" label="提取密码:" style="margin: 0px;height: 22px">
                  <span>{{ downloadPassword }}</span>
                </mtd-form-item>
              </mtd-form>
              <div class="complete-content-tips" style="margin-top:16px;">
                <span class="tips">2.点击文枢客户端‘打开报备目录’按钮，该目录下的文件可直接外发</span>
                <mtd-button class="tips-button" type="text" icon="mtdicon mtdicon-search" @click="open_client_dir()">
                  打开报备目录
                </mtd-button>
              </div>
            </div>
          </mtd-row>
        </div>
      </mtd-col>
    </mtd-row>

    <div style="margin-top: 32px">
      <mtd-row justify="center" type="flex">
        <div>
          <mtd-button size="large" @click="back_to_file_out"
                      style="width: 160px;color: #0A70F5;border: 1px solid #0A70F5;">继续外发
          </mtd-button>
        </div>
      </mtd-row>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import SendMessage from '../../../utils/db_client_messager.js'

export default {
  name: "file_out_completed",
  data() {
    return {
      pass: false,
      successTips: '（备注：外发记录已同步至您的上级）',
      outTips: '（审批成功后，该链接才能被访问）',
      fileOutUrl: '',
      bpmAddress: '',
      downloadPassword: '',
      checkingResult: '已经发起审批，如果长时间未反馈，可大象联系审批人进入审批详情页催办',
      passResult: '审批通过',
      noPassResult: '审批未通过',
      emailFlag: true,
      passAndEmailResult: '审批通过,链接已发送至邮箱',
      copyMessage: '',
      recordId: null,
      bpmStatus: null,
      approvalDetail: {
        list: [],
        currentNode: null,
      },
      bpmDetailData: null,
      approvalExpand: true,
      applyCreateTime: null,
      applyExpireHours: null,
      client_apply_ICP: null,
      createTimestamp: null,
      expireTimestamp: null,
    }
  },
  computed: {
    statusDefine() {
      return function (index) {
        if (index < this.approvalDetail.currentNode) {
          return 'finish';
        } else if (index === this.approvalDetail.currentNode) {
          if (this.approvalDetail.status === 1) {
            return 'finish';
          } else if (this.approvalDetail.status === 2 || this.approvalDetail.status === 6) {
            return 'error';
          } else if (this.approvalDetail.status === 3) {
            return 'process';
          }
        } else {
          return 'wait';
        }
      }
    },
  },
  mounted() {
    var shared = this.$route.params.shared;
    if (shared == null) {
      shared = {status: 0};
      console.log(shared)
      this.queryLastRecordInfo().then(res => {
        this.fileOutUrl = res.data.url;
        this.downloadPassword = res.data.password;
        this.bpmAddress = res.data.bpmDetails;
        this.recordId = res.data.recordId;
        this.bpmStatus = res.data.bpmStatus;
        this.applyCreateTime = res.data.createTime;
        this.applyExpireHours = res.data.expireHours;
        this.createTimestamp = res.data.createTimestamp;
        this.expireTimestamp = res.data.expireTimestamp;
        if (res.data.bpmStatus === 1) {
          this.pass = true;
        }
        if (res.data.fileOutEmails == null || res.data.fileOutEmails === '') {
          this.emailFlag = false;
        }
        this.client_apply_ICP = res.data.clientApplyIcp
        // 发送wss消息
        this.sendWSSMessageToClient();
      });
    } else {
      this.fileOutUrl = shared.url;
      this.downloadPassword = shared.password;
      this.bpmAddress = shared.bpmDetails;
      this.recordId = shared.recordId;
      this.bpmStatus = shared.status;
      this.applyCreateTime = shared.createTime;
      this.applyExpireHours = shared.expireHours;
      this.createTimestamp = shared.createTimestamp;
      this.expireTimestamp = shared.expireTimestamp;
      if (shared.status === 1) {
        this.pass = true;
      }
      let emails = this.$route.params.emails;
      if (emails == null || emails === '') {
        this.emailFlag = false;
      }
      this.client_apply_ICP = shared.clientApplyIcp
      // 发送wss消息
      this.sendWSSMessageToClient();
    }
  },
  methods: {
    ...mapActions([
      'queryLastRecordInfo',
      'queryApprovalDetails'
    ]),
    api_select_process(id) {
      if (!id) {
        return;
      }
      this.queryApprovalDetails({id}).then(res => {
        console.log(res);
        if (res.code === 0) {
          if (res.approvalList) {
            this.approvalDetail = res.approvalList;
          }
          this.bpmDetailData = res.data;
        }
      });
    },
    copyUrl() {
      let url = this.fileOutUrl;
      let pass = this.downloadPassword;
      let info = `文件分享链接： ${url} \n提取密码：${pass}`;
      this.copyMessage = info;
    },
    copySuccess() {
      this.$mtd.message({
        message: '链接已复制到剪切板',
        type: 'success',
      });
    },
    copyError() {
      this.$mtd.message({
        message: '复制失败',
        type: 'error',
      });
    },
    back_to_file_out() {
      this.$router.push({path: "continue_file_upload"});
    },
    open_client_dir() {
      let message = {
        msgType: '901',
        messageData: '打开外发报备目录'
      };
      // 新建客户端
      SendMessage(message).then((data) => {
        console.log("消息发送成功：" + data);
      }).catch((err) => {
        console.log("消息发送失败" + err);
      });
    },
    sendWSSMessageToClient() {
      let message = {
        msgType: '111',
        applyId: this.recordId + "",
        bpmStatus: this.bpmStatus + "",
        bpmUrl: this.bpmAddress,
        ICP: this.client_apply_ICP,
        createTime: this.createTimestamp,
        expireTime: this.expireTimestamp,
      };

      // 新建客户端
      SendMessage(message).then((data) => {
        console.log("消息发送成功：" + data);
      }).catch((err) => {
        console.log("消息发送失败" + err);
        this.sendMessageWithURLSchema();
      });
    },
    sendMessageWithURLSchema() {
      let url = 'cryptbox://cryptbox.sankuai.com/file_out';
      url += `?applyId=${this.recordId}&bpmStatus=${this.bpmStatus}&bpmUrl=${encodeURIComponent(this.bpmAddress)}&ICP=${this.client_apply_ICP}`;
      url += `&createTime=${this.createTimestamp}&expireTime=${this.expireTimestamp}`;
      window.location.href = url;
    }
  }
}
</script>

<style>

.dd-page-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.5px;
  line-height: 32px;
  font-weight: 500;
}

.dd-page-subtitle {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 22px;
  font-weight: 500;
}

.page-info-detail {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  line-height: 20px;
  font-weight: 400;
  margin-left: 10px;
}

.margin-bottom-0 {
  margin-bottom: 0;
}

h2.dd-page-title {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 33px;
  margin-bottom: 32px;
}

.file-upload-progress {
  height: 48px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  border-radius: 4px;
}

.mtd-progress .mtd-progress-bar .mtd-progress-bar-outer .mtd-progress-bar-inner {
  border-radius: 4px;
}

.mtd-progress .mtd-progress-bar .mtd-progress-bar-outer {
  border-radius: 4px;
}

.mtd-progress .mtd-progress-bar {
  padding: 0;
}

.mtd-progress .mtd-progress-percentage {
  display: none;
}

.file-out-result-title-complete {
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0 0;
  width: 100%;
  font-weight: 500;
  background: #F7F7F7;
  padding: 6px 16px;
  text-align: left;
}

.file-out-result-content-complete {
  border-radius: 0 0 4px 4px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-top: none;
  width: 100%;
  padding: 16px;
}

.shared-link-wrapper > .mtd-form-item-label {
  line-height: 22px;
}

.mtd-form-item-content {
  line-height: 22px;
}

.shared-link {
  word-wrap: break-word;
}

.approval-progress {
  background-color: white;
  padding: 16px 24px;
  border-radius: 10px;
}

.div-title {
  font-family: PingFang SC, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px;
  text-align: left;
}

.div-icon {
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 22px;
  font-weight: 400;
}

.progress-success-tips {
  font-family: PingFang SC, sans-serif;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  font-weight: 500;
  line-height: 18px
}

.demo-timeline-success {
  color: #5ABB3C;
  font-size: 20px;
  vertical-align: middle;
}

.demo-timeline-error {
  color: #FF6459;
  font-size: 20px;
  vertical-align: middle;
}

.demo-timeline-primary {
  color: #4E73FF;
  font-size: 20px;
  vertical-align: middle;
}

.approval-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px;
  margin-bottom: 8px;
}

.approval-img {
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border-radius: 100%;
}

.mtd-timeline-item-content-wrapper, .mtd-timeline-item-title {
  padding-bottom: 0px;
}

.mtd-step-finish .mtd-step-head-number {
  color: #00B365;
  border: 1px solid #00B365;
}

.mtd-steps-small.mtd-steps-vertical .mtd-step-main {
  top: -3px;
}

.br-div {
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.bpm-status-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.84);
  text-align: center;
  line-height: 26px;
  font-weight: 500;
}

.complete-content-tips {
  height: 24px;
}

.complete-content-tips .tips {
  float: left;
  text-align: left;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}

.complete-content-tips .tips-button {
  padding: 0;
  height: 24px;
  float: right;
  text-align: right;
}

.complete-content-tips .tips-button span {
  line-height: 24px;
}
</style>
